import { postRequestAndWaitForJobCompletion } from "../jobCompletion";
import * as Sortable from "sortablejs";
import { SortableEvent } from "sortablejs";
import { poisReorderedEventHandlerEventName } from "../../Components/TourMap/TourMapController";
import { TourType } from "../_generated/TourType";
import { ToursDetailStimulusModel } from "../_generated/ToursDetailStimulusModel";
import BaseStimulusModelController from "../../Features/BaseStimulusModelController";
import { translate } from "../translate";
import * as TranslationsKeys from "../locale/translationsKeys";
import { dialogCancelButtonClassName, dialogConfirmationButtonClassName } from "../dialogConstants";
import { reloadWithTurbo } from "../turboHelper";

export default class DetailController extends BaseStimulusModelController<ToursDetailStimulusModel> {
    static targets = [
        "pois",
        "poiIndex"
    ];

    readonly poisTarget!: HTMLElement;
    readonly poiIndexTargets!: HTMLSpanElement[];

    connect() {
        const _this = this;
        const poiDragAndDropClassName = "poi-drag-and-drop";
        new Sortable(this.poisTarget, {
            draggable: `.${poiDragAndDropClassName}`,
            onEnd(evt: SortableEvent) {
                if (evt.newIndex === undefined || evt.newIndex === evt.oldIndex) return;

                var poiCard = evt.item;
               
                const movePoiUrl = _this.modelValue.movePoiUrl
                    .replace("$poiContentUniqueId", poiCard.dataset.poiContentUniqueId!)
                    .replace("$newIndex", `${evt.newIndex}`);

                const pois = _this.poisTarget.getElementsByClassName(poiDragAndDropClassName);
                const poisCount = pois.length;

                if (evt.newIndex >= poisCount) return;

                if (_this.modelValue.tourType !== TourType.Indoor) {
                    const poiAutoGenerationSectionEnd = poiCard.getElementsByClassName("poiAutoGenerationSectionEnd").item(0) as HTMLDivElement;
                    if (evt.newIndex === poisCount - 1) {
                        poiAutoGenerationSectionEnd.style.visibility = "hidden";
                        const secondToLastPoiAutoGenerationSectionEnd = pois[poisCount - 2].getElementsByClassName("poiAutoGenerationSectionEnd").item(0) as HTMLDivElement;
                        secondToLastPoiAutoGenerationSectionEnd.style.visibility = "visible";
                    } else {
                        poiAutoGenerationSectionEnd.style.visibility = "visible";
                        const secondToLastPoiAutoGenerationSectionEnd = pois[poisCount - 1].getElementsByClassName("poiAutoGenerationSectionEnd").item(0) as HTMLDivElement;
                        secondToLastPoiAutoGenerationSectionEnd.style.visibility = "hidden";
                    }
                }
                
                postRequestAndWaitForJobCompletion(movePoiUrl, undefined, _this.modelValue.getJobUrl);

                _this.reindexPois();

                const orderedPoiContentUniqueIds = _this.poiIndexTargets.map(poiIndex => poiIndex.dataset.poiContentUniqueId!);

                _this.dispatch(poisReorderedEventHandlerEventName, { detail: orderedPoiContentUniqueIds, prefix: "" });
            },
        });
    }

    togglePoiRouteAutoGenerationSectionEnd(event) {
        const checkbox = event.currentTarget as HTMLInputElement;
        const isRouteAutoGenerationSectionEnd = !checkbox.checked;
        const poiContentUniqueId = checkbox.getAttribute("data-poi-content-unique-id");
        if (!poiContentUniqueId) throw new Error("Missing attribute data-poi-content-unique-id");
        const toggleRouteAutoGenerationSectionEndUrl = this.modelValue.toggleRouteAutoGenerationSectionEndUrl
            .replace("$poiContentUniqueId", poiContentUniqueId)
            .replace("$isRouteAutoGenerationSectionEnd", `${isRouteAutoGenerationSectionEnd}`);

        postRequestAndWaitForJobCompletion(
            toggleRouteAutoGenerationSectionEndUrl,
            undefined,
            this.modelValue.getJobUrl
        );
    }

    reindexPois() {
        this.poiIndexTargets.forEach((poiIndex, i) => {
            poiIndex.innerText = `${i + 1}`;
        });
    }

    async copyPoiContentUniqueId(event: Event) {
        const button = event.currentTarget as HTMLButtonElement;
        // @ts-ignore        
        await navigator.clipboard.writeText(button.dataset.poiContentUniqueId);
        const copyIcon = button.getElementsByClassName("fa-copy")[0] as HTMLElement;
        const checkIcon = button.getElementsByClassName("fa-check")[0] as HTMLElement;
        
        copyIcon.style.display = "none";
        checkIcon.style.display = "block";

        setTimeout(() => { 
            copyIcon.style.display = "block";
            checkIcon.style.display = "none";            
        }, 1000);
    }

    markTranslationAsReviewed(event) {
        const markTranslationAsReviewedUrl = this.modelValue.markTranslationAsReviewedUrl;
        const getJobUrl = this.modelValue.getJobUrl;
        const actionButton = $(event.currentTarget);

        bootbox.confirm({
            message: "Really confirm the Tour Overview translation has been reviewed?",
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                postRequestAndWaitForJobCompletion(
                    markTranslationAsReviewedUrl,
                    undefined,
                    getJobUrl,
                    actionButton,
                    () => {
                        reloadWithTurbo();
                    });
            }
        });
    }

    publish(event) {
        const publishTourUrl = this.modelValue.publishTourUrl;
        const getJobUrl = this.modelValue.getJobUrl;
        const actionButton = $(event.currentTarget);

        bootbox.confirm({
            message: "Really publish the tour?",
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                postRequestAndWaitForJobCompletion(
                    publishTourUrl,
                    undefined,
                    getJobUrl,
                    actionButton,
                    () => {
                        reloadWithTurbo();
                    });
            }
        });
    }
}
